import { apiClient } from './api';

export const tagService = {
  // Get all tags
  getTags: async () => {
    return await apiClient.get('/api/v1/tags');
  },

  // Create a new tag
  createTag: async (tagData) => {
    return await apiClient.post('/api/v1/tags', tagData);
  },

  // Update a tag
  updateTag: async (tagId, tagData) => {
    return await apiClient.put(`/api/v1/tags/${tagId}`, tagData);
  },

  // Delete a tag
  deleteTag: async (tagId) => {
    return await apiClient.delete(`/api/v1/tags/${tagId}`);
  },
};

export default tagService;
